
import React, {Component} from 'react'
import {compose} from 'redux'
import {connect} from 'react-redux'
import {translate} from 'react-i18next'
import Grid from '@material-ui/core/Grid'
import isNumber from 'lodash/isNumber'

import * as actions from '../../../actionTypes'
import {FACTOR_IMPORTANCE} from '../../../constants'
import ComparingImportanceSlider from './ComparingImportanceSlider'
import FormHeader from '../FormHeader'

class ComparingImportanceContainer extends Component {

  /* indices that represent each set of factors compared. First slider
     compares factor 0 and 1 , second slider 1 and 2, etc.. */
  static FACTORS_TO_COMPARE = [[0,1],[1,2],[0,2]]

  constructor(props) {
    super(props)
    this.amendNavigation()
    this.initFactorComparison()
  }

  amendNavigation() {
    const back = () => this.props.navigator.cdi === 0
    const forward = () => {
      const {navigator, topFactors} = this.props
      return topFactors.length < 3 || topFactors.length - 1 === navigator.cdi
    }
    this.props.navigator.amendNavigation({back, forward})
  }

  componentDidUpdate(prevProps) {
    const {navigator} = this.props
    if(isNumber(navigator.cdi) && prevProps.navigator.cdi !== navigator.cdi) {
      this.handleCdiChange()
    }
  }

  getComparisonTooltips(cdi) {
    const factorIndices = ComparingImportanceContainer.FACTORS_TO_COMPARE[cdi]

    const {t, topFactors} = this.props

    const [thisCdi, nextCdi] = factorIndices

    return (
      <div>
        {t('Indicate How Much More', {FACTORA: topFactors[thisCdi], FACTORB: topFactors[nextCdi]})}
      </div>
    )
  }

  handleCdiChange() {
    if (this.props.compareWeightedFactors.length) {
      const weight = this.props.compareWeightedFactors[this.props.navigator.cdi].weight
      this.updateNavigation(weight)
    }
  }

  handleSliderChange(weight) {
    const {navigator, resetFinalWeight, updateCompareWeight} = this.props
    resetFinalWeight()
    updateCompareWeight(navigator.cdi, weight)
    this.updateNavigation(weight)
  }

  initCompareWeightedFactors() {
    const {compareWeightedFactors, setCompareWeightedFactors, topFactors} = this.props
    if(!compareWeightedFactors.length) {
      const compareWeightedFactors = topFactors.map(text => ({text, weight: FACTOR_IMPORTANCE.uninitializedWeight}))
      setCompareWeightedFactors(compareWeightedFactors)
    }
  }

  initFactorComparison() {
    const {navigator: {cdi}} = this.props
    this.initCompareWeightedFactors()
    if(isNumber(cdi)) {
      this.handleCdiChange()
    }
  }

  render() {
    const {compareWeightedFactors, isCounselingSessionDisabled, navigator, t} = this.props
    const factor = compareWeightedFactors[navigator.cdi]
    return (
      <Grid
        alignContent="flex-start"
        className="counseling-session-page-container"
        container
        justify="center"
        spacing={8}
      >
        {factor && (
          <React.Fragment>
            <FormHeader
              description={this.getComparisonTooltips(navigator.cdi)}
              stepNumber={t(`Step ${navigator.getStepNumber()}`)}
            />
            <Grid item xs={10}>
              <ComparingImportanceSlider
                disabled={isCounselingSessionDisabled}
                key={navigator.cdi}
                onChange={weight => this.handleSliderChange(weight)}
                weight={factor.weight}
              />
            </Grid>
          </React.Fragment>
        )}
      </Grid>
    )
  }

  updateNavigation(weight) {
    const {navigator} = this.props
    if(weight) {
      navigator.enableForward()
    } else {
      navigator.disableForward()
    }
  }
}

const mapDispatchToProps = dispatch => ({
  resetFinalWeight() {
    const action = {type: actions.RESET_FINAL_WEIGHT}
    dispatch(action)
  },
  setCompareWeightedFactors(compareWeightedFactors) {
    const action = {type: actions.SET_COMPARE_WEIGHTED_FACTORS, payload: {compareWeightedFactors}}
    dispatch(action)
  },
  updateCompareWeight(index, weight) {
    const action = {type: actions.FACTOR_COMPARE_UPDATE_WEIGHT, payload: {index, weight}}
    dispatch(action)
  }
})

const mapStateToProps = state => ({
  compareWeightedFactors: state.counselingSession.counselingSessionData.topThreeFactorsWithCompareWeights,
  topFactors: state.counselingSession.counselingSessionData.topThreeFactors
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  translate()
)(ComparingImportanceContainer)


// WEBPACK FOOTER //
// ./src/components/counseling-session/comparing-importance/ComparingImportanceContainer.js